import React, { useEffect, useMemo, useState } from "react";
import style from "./index.module.scss";
import { Button, Divider, Input, Spin } from "antd";
import CustomEmpty from "../../../../components/CustomEmpty";
import classNames from "classnames";
import { errorMessage } from "Utils/useRequest";
import { ExperiState, getMyExperimentAllList } from "API/navExperiment";
import useRequestFn from "Utils/useRequestFn";
import { ResultMessage } from "components/ResultMessage";
import ListItem from "../ListItem";

export default function OrderList() {
    const [filter, setFilter] = useState("all");
    const [search, setSearch] = useState("");
    const [getData, { loading, data: list }] = useRequestFn(
        getMyExperimentAllList
    );

    useEffect(() => {
        getData();
    }, []);

    async function handleSearch() {
        try {
            await getData(search);
        } catch (e) {
            ResultMessage.error(errorMessage(e));
        }
    }

    const filteredMarkList = useMemo(() => {
        if (!list) return;

        return list.filter((item: any) => {
            if (filter === "all") return true;
            if (filter === "noStart")
                return item.status === ExperiState.noStart;
            if (filter === "doing") return item.status === ExperiState.doing;
            if (filter === "done") return item.status === ExperiState.done;
        });
    }, [list, filter]);

    function handleClick(params: string) {
        setFilter(params);
    }

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.tools}>
                    <div
                        className={classNames(style.statics, {
                            [style.active]: filter === "all"
                        })}
                        onClick={() => handleClick("all")}>
                        <span>
                            全部计划
                            <Divider type="vertical" />
                        </span>
                    </div>
                    <div
                        className={classNames(style.statics, {
                            [style.active]: filter === "noStart"
                        })}
                        onClick={() => handleClick("noStart")}>
                        {" "}
                        <span>
                            未开始
                            <Divider type="vertical" />
                        </span>
                    </div>
                    <div
                        className={classNames(style.statics, {
                            [style.active]: filter === "doing"
                        })}
                        onClick={() => handleClick("doing")}>
                        <span>
                            进行中
                            <Divider type="vertical" />
                        </span>
                    </div>
                    <div
                        className={classNames(style.statics, {
                            [style.active]: filter === "done"
                        })}
                        onClick={() => handleClick("done")}>
                        <span>已结束</span>
                    </div>
                </div>
                <div className={style.search}>
                    <div>
                        <Input
                            placeholder="输入项目名称或计划名称"
                            className={style.input}
                            maxLength={50}
                            onChange={e => setSearch(e.target.value)}
                            onPressEnter={handleSearch}
                        />
                        <Button
                            type="primary"
                            className={style.searchBtn}
                            icon="search"
                            onClick={handleSearch}>
                            查询
                        </Button>
                    </div>
                </div>
            </div>

            <div className={style.length}>
                实验计划（{filteredMarkList?.length || "0"}）
            </div>

            <Spin spinning={loading}>
                {filteredMarkList?.map(item => (
                    <ListItem
                        key={item.id}
                        data={item}
                        refreshData={handleSearch}
                    />
                ))}
                {!filteredMarkList?.length && (
                    <CustomEmpty
                        style={{ padding: "220px 0" }}
                        description="暂无实验计划"
                    />
                )}
            </Spin>
        </div>
    );
}
